
import Vue from "vue";
import { IInvoiceData } from "../types";
import { DATE_FORMAT } from "../constants/DateFormats";
import fieldEntryMixin from "@/components/mixins/fieldEntryMixin.vue";

export default Vue.extend({
  name: "invoice-table-row",
  mixins: [fieldEntryMixin],
  props: {
    invoice: {
      type: Object as () => IInvoiceData
    }
  },
  computed: {
    dateFormated(): any {
      // @ts-ignore
      return this.$moment(this.invoice.baselinePaymentDate).format(
        DATE_FORMAT.LOCAL_DATE_FORMAT
      );
    },
    amount(): string {
      let isNegative: boolean = true;

      if (
        this.invoice.documentNumber.startsWith("78") ||
        this.invoice.documentNumber.startsWith("18")
      ) {
        isNegative = false;
      }

      //@ts-ignore
      return this.formatPrice(this.invoice.amountDue, isNegative);
    }
  }
});
